var _class, _SelectableButtonItem;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import Button from '../button';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let SelectableButtonItem = (_class = (_SelectableButtonItem = class SelectableButtonItem extends Component {
  get value() {
    return this.args.value;
  }
  get isSelected() {
    return this.value != null && this.value === this.args.selectedValue;
  }
  update() {
    if (!this.args.isReadOnly) {
      if (!this.args.keepSelected) {
        this.args.onChange(this.isSelected ? null : this.value);
      } else {
        if (!this.isSelected) {
          this.args.onChange(this.value);
        }
      }
      this.args.onSelectedUpdate?.(this.value);
    }
  }
  get disabledStyle() {
    return this.args.isReadOnly ? 'disabled' : '';
  }
  get sizeStyle() {
    return this.args.xs ? 'p-3' : '';
  }
  get selectedStyle() {
    if (!this.isSelected) return '';
    // For test purposes only. This is the legacy ember-css-modules string that was used in tests
    const testStyle = 'is-selected-btn';
    if (this.args.selectedColor == 'grey') return `${testStyle} !bg-[#808080] !text-black`;
    return `${testStyle} !bg-pink !text-white`;
  }
  get styles() {
    return `${this.disabledStyle} ${this.sizeStyle} ${this.selectedStyle}`;
  }
}, setComponentTemplate(precompileTemplate("\n    <Button ...attributes class={{this.styles}} type=\"button\" data-test-selectable-btn={{@value}} data-test-selected={{if this.isSelected \"true\" \"false\"}} {{on \"click\" this.update}}>\n      {{yield}}\n    </Button>\n  ", {
  strictMode: true,
  scope: () => ({
    Button,
    on
  })
}), _SelectableButtonItem), _SelectableButtonItem), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _class);
export { SelectableButtonItem as default };